(function () {
  'use strict';

  class PesosEventosCtrl {
    constructor($scope, $uibModal, Restangular, AlertMessage, AlertasEnum,
      Keys, ServiceVfiltro, FactoryVfiltro, $translate, ConfigEventosService, $q, SpeedingBucketService, FeatureOuService,
      UoHelperService, FeaturehubJsSdk, FeatureHubConfigKeys) {
      this.scope = $scope;
      this.modalService = $uibModal;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.alertasEnum = AlertasEnum;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;
      this.configEventosService = ConfigEventosService;
      this.q = $q;
      this.speedingBucketService = SpeedingBucketService;
      this.featureOuService = FeatureOuService;
      this.uoHelperService = UoHelperService;
      this.featRollingStop = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ROLLING_STOP);

      this.uoId = 0;
      this.roleCadastrar = true;
      this.model = {configuracoes: []};
      this.speedingLevels = null;
      this.eventNaConfig = false;

      this.NaFeatureExcludedEvents = [
        'CURVA_BRUSCA',
        'VEICULO_SEM_VIGENCIA'
      ];

      this.serviceVfiltro.init(FactoryVfiltro.get([
        {
          key: this.keys.uo.name
        }
      ]))
      .then((filtro) => {
        this.uoId = filtro.find(x => x.key === this.keys.uo.name).value.id;
        this.roleCadastrar = this.temPermissaoParaConfigurar();
        this.init();
      });
    }

    temPermissaoParaConfigurar() {
      return this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('CONFIG_PESO_EVENTO_EDITAR') &&
      this.uoHelperService.isDirectChildOfRoot(this.serviceVfiltro.factoryVfiltro.user.uo) &&
      this.serviceVfiltro.factoryVfiltro.user.uo.id === this.uoId;
    }

    init() {
      this.q.all([
        this.restangular.one(`configuracao/configuracoes/${this.uoId}/pontuacao`).get(),
        this.configEventosService.getConfigEventos(),
        this.speedingBucketService.getFormattedSpeedingLevels(this.uoId),
        this.getEventNaConfig(this.uoId)
      ])
      .then(([alertas, configEventos, speedingLevels, eventNaConfig]) => {
        this.speedingLevels = speedingLevels;
        this.setConfiguracoes(alertas, configEventos);
        this.eventNaConfig = eventNaConfig;
      })
      .catch(() => this.alertMessage.create({
        type: 'error',
        message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.msgErroCarregarConfiguracoes'),
        appendTo: '.alerta-aqui-geral'
      }));
    }

    getSpeedingLevelTitle(subAlerta) {
      if (!this.speedingLevels) {
        return this.translate.instant(subAlerta.alertaEnum.descricaoCurta);
      }

      const nivel = this.getSpeedingNivel(subAlerta.tipoOcorrencia);

      if (nivel && this.speedingLevels.useBuckets && this.speedingLevels[nivel] && this.speedingLevels[nivel].levelLabel) {
        return this.speedingLevels[nivel].levelLabel;
      }

      return this.translate.instant(subAlerta.alertaEnum.descricaoCurta);
    }

    getSpeedingNivel(tipoEvento) {
      if (tipoEvento.includes('ALTO') || tipoEvento.includes('ACIMA_30')) return 'ALTO';
      if (tipoEvento.includes('MEDIO') || tipoEvento.includes('30')) return 'MEDIO';
      if (tipoEvento.includes('BAIXO') || tipoEvento.includes('20')) return 'BAIXO';
      return null;
    }

    setConfiguracoes(alertas, configEventos) {
      let excVel = [],
          excVelVia = [],
          curvaBrusca = [],
          cameraObstruida = [];

      this.model.uoId = alertas.uoId;
      this.model.heranca = alertas.heranca;

      const filteredConfiguracoes = alertas.configuracoes.filter(alerta => {
        const excludeConditions = [
          this.alertasEnum.DIAGNOSTICO_OBD.id,
          this.alertasEnum.MANUTENCAO_PROGRAMADA.id,
          'TREPIDACAO',
          this.alertasEnum.VEICULO_SEM_SINAL.id,
          this.alertasEnum.PREVISAO_COLISAO.id,
          this.alertasEnum.RFID_NAO_CADASTRADO.id,
          this.alertasEnum.MANUTENCAO_PROGRAMADA_HORIMETRO.id,
          this.alertasEnum.PANICO.id
        ];

        if (this.eventNaConfig) {
          excludeConditions.push(...this.NaFeatureExcludedEvents);
        }

        if (!this.featRollingStop) {
          excludeConditions.push(this.alertasEnum.ROLLING_STOP.id, this.alertasEnum.NO_STOP.id);
        }

        return !excludeConditions.includes(alerta.tipoOcorrencia);
      });

      this.model.configuracoes = filteredConfiguracoes.map(alerta => {
        const alertaEnum = this.alertasEnum.getAlerta(alerta.tipoOcorrencia);
        if (alertaEnum) {
          if (this.alertasEnum.isExcessoVelocidade(alertaEnum.id)) {
            excVel.push(alerta);
            return null;
          } else if (this.alertasEnum.isExcessoVelocidadeVia(alertaEnum.id)) {
            excVelVia.push(alerta);
            return null;
          } else if (alertaEnum && this.alertasEnum.CURVA_BRUSCA.id === alertaEnum.id) {
            curvaBrusca.push(alerta);
            return null;
          } else if (alertaEnum && this.alertasEnum.CAMERA_OBSTRUIDA.id === alertaEnum.id) {
            cameraObstruida.push(alerta);
            return null;
          }
          return angular.extend(alerta, this.extendDefault(alerta, alertaEnum, null, []));
        }
        return null;
      }).filter(x => !!x && x.alertaEnum.isEnabled(configEventos));

      this.buildExcessoVelocidade(
        excVel,
        this.alertasEnum.EXCESSO_VELOCIDADE
      );
      this.buildExcessoVelocidade(
        excVelVia,
        this.alertasEnum.EXCESSO_VELOCIDADE_POR_VIA
      );
      this.buildExcessoVelocidade(
        curvaBrusca,
        this.alertasEnum.CURVA_BRUSCA
      );
      this.buildExcessoVelocidade(
        cameraObstruida,
        this.alertasEnum.CAMERA_OBSTRUIDA
      );
    }

    getEventNaConfig(uoId) {
      return this.featureOuService.getEventsConfig(uoId).then((eventNaConfig) => {
        this.eventNaConfig = eventNaConfig;
      });
    }

    buildExcessoVelocidade(lista, alertaEnum) {
      if (lista.length > 0) {
        lista = lista.map(alerta =>
          angular.extend(
            alerta,
            this.extendDefault(alerta, this.alertasEnum.getAlerta(alerta.tipoOcorrencia), null, [])
          )
        );
        this.model.configuracoes.push(angular.extend({
          lista
        }, this.extendDefault({}, alertaEnum, lista)));
      }
    }

    extendDefault(alerta, alertaEnum, lista) {
      return {
        alertaEnum,
        backupMultiplicadorUnitario: alerta.multiplicadorUnitario >= 0 ? angular.copy(alerta.multiplicadorUnitario) : null,
        backupMultiplicadorTempo: alerta.multiplicadorTempo >= 0 ? angular.copy(alerta.multiplicadorTempo) : null,
        backupLista: angular.copy(lista) || []
      };
    }

    checkError(error, alertaEnum, alertaLista) {
      return error && !!Object.keys(error)
      .find(tipo => !!error[tipo]
        .find(item => {
          if (alertaLista && alertaLista.length > 0) {
            return !!alertaLista.find(alerta => alerta.alertaEnum.id === item.$name.split('.')[1]);
          }
          return item.$name.split('.')[1] === alertaEnum.id;
        })
      );
    }

    descartarAlteracoes() {
      this.model.configuracoes = this.model.configuracoes.map(item => {
        if (item.backupMultiplicadorUnitario >= 0) {
          item.multiplicadorUnitario = angular.copy(item.backupMultiplicadorUnitario);
        }
        if (item.backupMultiplicadorTempo >= 0) {
          item.multiplicadorTempo = angular.copy(item.backupMultiplicadorTempo);
        }
        if (item.backupLista.length > 0) {
          item.lista = angular.copy(item.backupLista);
        }
        return item;
      });
    }

    abrirModal() {
      this.modalService.open({
        animation: true,
        templateUrl: 'configuracoes/eventos/modal/reset/reset-eventos.tpl.html',
        controller: 'ModalResetEventosCtrl',
        controllerAs: '$ctrl'
      })
      .result
      .then(() => {
        this.salvar(true);
      });
    }

    buildConfiguracoes(item) {
      let itemFinal = {tipoOcorrencia: item.tipoOcorrencia};

      if (item.multiplicadorUnitario >= 0) {
        itemFinal.multiplicadorUnitario = item.multiplicadorUnitario;
      }
      if (item.multiplicadorTempo >= 0) {
        itemFinal.multiplicadorTempo = item.multiplicadorTempo;
      }

      return itemFinal;
    }

    getConfiguracoes() {
      let lista = [];

      this.model.configuracoes.forEach(item => {
        if (item.backupLista.length > 0) {
          item.lista.forEach(alerta => lista.push(this.buildConfiguracoes(alerta)));
        } else {
          lista.push(this.buildConfiguracoes(item));
        }
      });

      return lista;
    }

    salvar(heranca) {
      const config = this.getConfiguracoes(),
          pontuacao = {
            uoId: this.uoId,
            heranca,
            configuracoes: config
          };

      Promise.all([
        this.restangular.all(`configuracao/configuracoes/${this.uoId}/pontuacao`).post(pontuacao)
      ])
      .then(([pesos]) => {
        if (pesos) {
          this.rebuildPesos(pesos);
        }
      })
      .catch(() => {
        this.alertMessage.create({
          type: 'error',
          message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.erroSalvarConfiguracoes'),
          appendTo: '.alerta-aqui'
        });
      });
    }

    rebuildPesos(pesos) {
      this.scope.formPesos.$setPristine();
      this.setConfiguracoes(pesos);
      this.alertMessage.create({
        type: 'success',
        message: this.translate.instant('ce.configuracao.eventos.itensConfiguraveis.pesoEventos.botaoRestaurarConfiguracoes.modal.salvoComSucesso'),
        appendTo: '.alerta-aqui'
      });
      this.scope.$apply();
    }
  }

  angular
    .module('SubpaginasEventos')
    .controller('PesosEventosCtrl', PesosEventosCtrl);
}());
